import { c as _c } from "react/compiler-runtime";
import { STARS_NUMBER } from '../constants';
import styles from './index.module.scss';
const getScorePercentage = (score: number): number => score * 100;
interface Props {
  score: number;
  textualScore: string;
  color?: string;
}
const getValidColor = (color: string): string | undefined => /^#[0-9A-F]{6}$/i.test(color) ? color : undefined;
export const Stars = t0 => {
  const $ = _c(17);
  const {
    score,
    textualScore,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = color ? getValidColor(color) : undefined;
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const validColor = t1;
  let t2;
  if ($[2] !== textualScore) {
    t2 = <title id="starRatingTitle">Valutazione: {textualScore} su {STARS_NUMBER}</title>;
    $[2] = textualScore;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path id="star" d="M10.471 5.267L8.453.964c-.118-.25-.415-.357-.665-.24-.106.05-.191.135-.24.24l-2.02 4.303-4.566.697c-.273.042-.46.297-.419.57.016.103.064.2.136.274L4 10.21l-.778 4.773c-.044.272.14.53.413.574.111.018.225-.002.323-.056L8 13.267l4.043 2.235c.242.133.546.046.68-.196.054-.098.074-.212.055-.322L12 10.21l3.32-3.403c.193-.198.19-.514-.008-.707-.075-.073-.17-.12-.274-.137l-4.567-.697z" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <defs>{t3}<clipPath id="star-clip-path">{Array.from({
          length: 5
        }).map(_temp)}</clipPath></defs>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <g fill="#DFE3ED">{Array.from({
        length: 5
      }).map(_temp2)}</g>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== score) {
    t6 = getScorePercentage(score).toString();
    $[7] = score;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = `${t6}%`;
  let t8;
  if ($[9] !== validColor) {
    t8 = {
      fill: validColor
    };
    $[9] = validColor;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t7 || $[12] !== t8) {
    t9 = <rect className={styles.rect} x="0" y="0" width={t7} height="100%" clipPath="url(#star-clip-path)" style={t8} />;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t2 || $[15] !== t9) {
    t10 = <div className={styles.stars}><svg viewBox="0 0 80 16" xmlns="http://www.w3.org/2000/svg" aria-labelledby="starRatingTitle">{t2}{t4}{t5}{t9}</svg></div>;
    $[14] = t2;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
};
function _temp(_, i) {
  return <use key={i * 16} xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#star" x={i * 16} />;
}
function _temp2(__0, i_0) {
  return <use key={i_0 * 16} xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#star" x={i_0 * 16} />;
}